import React from 'react';

export default function SecurityUnblockConfirm({
  ipAddress,
  busy,
  onCancel,
  onConfirm,
}) {
  if (!ipAddress) return null;

  return (
    <div className="admin-drawer-overlay vx-sec-confirm-overlay" onClick={onCancel}>
      <div
        className="vx-sec-confirm-dialog"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="security-unblock-title"
      >
        <h3 id="security-unblock-title">Unblock IP address</h3>
        <p>
          Unblock <code className="vx-sec-confirm-ip">{ipAddress}</code>? Traffic from this address will
          be allowed again.
        </p>
        <div className="vx-sec-confirm-actions">
          <button type="button" className="btn" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="btn vx-sec-confirm-danger" onClick={onConfirm} disabled={busy}>
            {busy ? 'Unblocking…' : 'Unblock'}
          </button>
        </div>
      </div>
    </div>
  );
}
